import React from "react";

import ProductPage from "../../../components/ProductPage";

import hero from "../../../img/lenses.jpg";
import adviceIcon from "../../../img/advice.svg";
import choicesIcon from "../../../img/choices.svg";
import contactLensIcon from "../../../img/contact-lens.svg";
import reviewImage from "../../../img/person-for-products2.jpg";

const Cocky = () => (
  <ProductPage
    title="Kontaktní čočky"
    centeredHeading
    description="Služby týkající se kontaktních čoček, které Optika Volyně nabízí"
    keywords="Optika, Optometrie, Volyně, Kontaktní čočky, Oči"
    hero={hero}
    heroAlt="foto kontaktních čoček"
    boxes={[
      {
        icon: adviceIcon,
        iconAlt: "ikona poradenstvi",
        heading: "Poradenství",
        text: "Jsou pro vás kontaktní čočky zatím velkou neznámou? Nemusíte se bát, u nás vám s jejich výběrem i funkcemi rádi poradíme, vše vám vysvětlíme a doporučíme vám to, co je pro vaše oči nejlepší.",
      },
      {
        icon: choicesIcon,
        iconAlt: "ikona vyberu",
        heading: "Výběr",
        text: "Vybírat si můžete z celé řady kontaktních čoček. V nabídce máme jednodenní, dvoutýdenní i měsíční typy čoček a najdete tak přesně takové, které budou odpovídat vašemu životnímu stylu a potřebám.",
      },
      {
        icon: contactLensIcon,
        iconAlt: "ikona aplikace cocek",
        heading: "Aplikace",
        text: "Pokud s čočkami začínáte, rádi vám s prvním seznamováním pomůžeme. Naučíme vás, jak o čočky pečovat, jakým způsobem se dají co nejpříjemněji nasazovat a také následně vyjímat z očí.",
      },
    ]}
    review={{
      text: "Když jsem poprvé uvažovala o kontaktních čočkách, měla jsem docela velký strach. Mám velmi citlivé oči a nedokázala jsem si představit, jak si budu každý den čočky aplikovat. V optice Volyně mi však poradili s výběrem a naučili mě čočky používat tak, že jsem to skoro necítila.",
      image: reviewImage,
      imageAlt: "referentka Markéta",
      name: "Markéta",
    }}
  />
);

export default Cocky;
